
import {  mapGetters,  } from 'vuex';
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  props: {
    products: {
      // required: true,
      type: Array,
      default: () => [],
    },
    isLoaded: {
      required: false,
      type: Boolean,
      default: true,
    },
    options: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultOptions: {
        mainCols: 9,
      },

      sortingName: null,
      sortingStyle: null,
      sortingStyles: [],
      cardCols: 4,
      itemsPerPage: 9,
      filters: [
        {
          name: 'Likes',
          labels: ['Most Liked', 'Least Liked'],
          values: ['ml', 'll'],
        },
        {
          name: 'Sale Type',
          labels: ['Freemium', 'On Sale', 'Fixed Price', 'Free'],
          values: ['fm', 'os', 'fp', 'fe'],
        },
        {
          name: 'Category',
          labels: [
            'All',
            'After Effects',
            'Photoshop',
            'Premiere Pro',
            'Illustrator',
            'Apps Manager',
          ],
          values: ['al', 'ae', 'ps', 'pp', 'il', 'am'],
        },
        {
          name: 'Sort By',
          labels: ['Lowest Price', 'Highest Price', 'A to Z', 'Z to A'],
          values: ['lp', 'hp', 'az', 'za'],
        },
      ],
    };
  },
  methods: {
    filterUpdated([sortingStyle, name]) {
      if (name) {
        // Update the sorting styles array based on the selected filter
        const index = this.filters.findIndex((filter) => filter.name === name);
        if (index !== -1) {
          const filter = this.filters[index];
          this.sortingStyles = this.sortingStyles.filter(
            (style) => !filter.labels.includes(style)
          );
          this.sortingStyles.push(sortingStyle);
          this.sortingName = this.sortingStyles.join('-');
        }
      }
    },
  },
  computed: {
        ...mapGetters('global', ['getAffiliateDiscount']),
    filteredAndSortedProducts() {
      // Make a copy of the products array to not mutate the original data
      const result = [...this.products];

      // Apply sorting based on the selected filters
      const sortingFunctions = {
        'Lowest Price': (a, b) =>
          (a.pricing.discount ? a.pricing.basePrice * (1 - a.pricing.discount / 100) : a.pricing.basePrice) -
          (b.pricing.discount ? b.pricing.basePrice * (1 - b.pricing.discount / 100) : b.pricing.basePrice),
        'Highest Price': (a, b) =>
          (b.pricing.discount ? b.pricing.basePrice * (1 - b.pricing.discount / 100) : b.pricing.basePrice) -
          (a.pricing.discount ? a.pricing.basePrice * (1 - a.pricing.discount / 100) : a.pricing.basePrice),
        'Most Liked': (a, b) => b.likes - a.likes,
        'Least Liked': (a, b) => a.likes - b.likes,
        'A to Z': (a, b) => a.productName.localeCompare(b.productName),
        'Z to A': (a, b) => b.productName.localeCompare(a.productName),
      };

      const sortingFunction =
        sortingFunctions[this.sortingStyles.find((style) => style in sortingFunctions)] ||
        (() => 0);

      // Apply sorting
      result.sort(sortingFunction);

      // Apply filters based on the selected sale type
      const saleTypeFilters = {
        'On Sale': (product) => product.pricing.discount,
        'Fixed Price': (product) => product.pricingModel === 'Fixed Price',
        'Free': (product) => product.pricingModel === 'Free',
        'Freemium': (product) => product.pricingModel === 'Freemium',
      };

      const saleTypeFilter =
        saleTypeFilters[this.sortingStyles.find((style) => style in saleTypeFilters)] ||
        (() => true);

      // Apply filters based on the selected category
      const categoryFilters = {
        'After Effects': (product) =>
          product.productCategory.includes('After Effects'),
        Photoshop: (product) =>
          product.productCategory.includes('Photoshop'),
        'Premiere Pro': (product) =>
          product.productCategory.includes('Premiere Pro'),
        Illustrator: (product) =>
          product.productCategory.includes('Illustrator'),
        'Apps Manager': (product) =>
          product.productCategory.includes('Apps Manager'),
      };

      const categoryFilter =
        categoryFilters[this.sortingStyles.find((style) => style in categoryFilters)] ||
        (() => true);

      // Apply filters
      return result.filter((product) => saleTypeFilter(product) && categoryFilter(product));
    },
    mergedOptions() {
      return {
        ...this.defaultOptions,
        ...this.options,
      };
    },
    // Define a watcher to set isLoaded when filteredAndSortedProducts() changes
  },
};
